export const dropdownAnimation = {
	offerDropdown: function ($root = document) {
		// console.log('dropdownAnimation => offerDropdown');

		let dropdownWrapper = $root.querySelectorAll('.dropdownContainer');
		[].forEach.call(dropdownWrapper, el => {
			let dropdownOptions = el.querySelectorAll('.dropdownOption');

			dropdownAnimation.setActiveOption(el, dropdownOptions[0]);
			dropdownAnimation.fillDropdownPositions(el, dropdownOptions);
			if (!el.bindedPopupOpen) {
				el.bindedPopupOpen = true;
				el.addEventListener('click', (e) => dropdownAnimation.showHideOptions(el, dropdownWrapper, e));
			}
			dropdownAnimation.hideWhenClickingOutside(el);
		});
	},

	setActiveOption: function (container, option) {
		option.className += ' offer-dropdown__option--active';
		let activeDropdownLink = option.firstElementChild;
		activeDropdownLink.className += ' offer-dropdown__option-link--active';
		if (!container.hasAttribute('data-select-type')) {
			activeDropdownLink.setAttribute("data-clickable", false);
		}
		activeDropdownLink.setAttribute("aria-expanded", false);
		// activeDropdownLink.removeAttribute("href");        
	},

	fillDropdownPositions: function (container, dropdownOptions) {
		let hiddenOptionsWrapper = document.createElement('div');
		let hiddenOptionsWrapperContainer = document.createElement('div');
		let hiddenOptionsWrapperContainerAbsolute = document.createElement('div');
		hiddenOptionsWrapper.setAttribute('class', 'offer-dropdown__options-wrapper');
		hiddenOptionsWrapperContainer.setAttribute('class', 'offer-dropdown__options-wrapper-container');
		hiddenOptionsWrapperContainerAbsolute.setAttribute('class', 'offer-dropdown__options-wrapper-container-absolute');
		hiddenOptionsWrapperContainer.appendChild(hiddenOptionsWrapper);
		hiddenOptionsWrapperContainerAbsolute.appendChild(hiddenOptionsWrapperContainer);
		container.removeChild(container.lastChild);
		container.appendChild(hiddenOptionsWrapperContainerAbsolute);
		// console.log('container', container);

		[].forEach.call(dropdownOptions, (el, index) => {
			if (container.hasAttribute('data-select-type')) {
				let singleElement;
				if (index === 0) {
					const clonedElement = dropdownOptions[index].cloneNode(true);
					singleElement = dropdownOptions[index];
					container.insertBefore(clonedElement, container.childNodes[0]);
					singleElement.classList.remove('offer-dropdown__option--active');
					singleElement.querySelector('button').classList.remove('offer-dropdown__option-link--active');
				}
				else {
					singleElement = dropdownOptions[index];
				}
				hiddenOptionsWrapper.appendChild(singleElement);
				// console.log(' ------- singleElement', singleElement);
			}
			else {
				if (index >= 1) {
					const singleElement = dropdownOptions[index];
					hiddenOptionsWrapper.appendChild(singleElement);
				}
			}
		})
	},

	showHideOptions: function (activeElement, otherElements, e) {
		// console.log('click');
		if (e.target.getAttribute("data-clickable") === "false") {
			e.preventDefault();
		}
		e.target.setAttribute("aria-expanded", false);
		let isDropdownOpened = activeElement.classList.contains("active");
		[].forEach.call(otherElements, el => el.classList.remove("active"));
		if (!isDropdownOpened) {
			activeElement.classList.toggle("active");
			e.target.setAttribute("aria-expanded", true);
		}
	},

	hideWhenClickingOutside: function (element) {
		document.addEventListener("click", (event) => {
			let target = event.target;
			if (!target.classList.contains("dropdownLink")) {
				element.classList.remove("active");
			}
		})
	}
}
